import { ThemeColorKeys, ThemeColors } from '@evrekadev/evreka-ui-components'
import { MapMarkerProps } from '../MapMarker'

export const MarkerIcon: React.FC<{
  id: string
  fill?: ThemeColorKeys
  customFill?: string
  isSelected?: boolean
  isAdhoc?: boolean
  badge?: MapMarkerProps['badge']
  'data-testid'?: string
}> = ({
  id,
  fill = 'green500',
  isSelected,
  customFill,
  isAdhoc,
  badge,
  'data-testid': dataTestId,
}) => {
  let accentColor = ThemeColors[fill] || customFill
  let fillColor = ThemeColors['white']

  if (isSelected) {
    accentColor = ThemeColors['white']
    fillColor = ThemeColors[fill] || customFill
  }

  if (isAdhoc) {
    accentColor = ThemeColors['grey600']
    fillColor = ThemeColors['white']
  }

  return (
    <div data-testid={dataTestId}>
      {badge && (
        <div
          id={`marker-badge-wrapper_${id}`}
          style={{
            position: 'absolute',
            top: badge.top ?? 0,
            right: badge.right ?? 0,
            bottom: badge.bottom ?? undefined,
            left: badge.left ?? undefined,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {badge.content}
        </div>
      )}
      {/* <svg
        width="22"
        height="26"
        viewBox="0 0 22 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.4501 9.97998L21.4502 9.98094C21.6014 11.5216 21.4073 13.0766 20.8819 14.5331C20.3565 15.9896 19.513 17.3111 18.4124 18.4018L18.4101 18.4041L11.5774 25.265L11.577 25.2654C11.5032 25.3397 11.4154 25.3987 11.3186 25.439C11.2218 25.4793 11.1179 25.5 11.0129 25.5C10.908 25.5 10.8041 25.4793 10.7073 25.439C10.6105 25.3987 10.5227 25.3397 10.4489 25.2654L10.4478 25.2643L3.58925 18.4034L3.58758 18.4018C2.48702 17.3111 1.64347 15.9896 1.11806 14.5331C0.592688 13.0767 0.398587 11.5218 0.549822 9.98119C0.704166 8.42963 1.20074 6.9314 2.00391 5.59413C2.80699 4.25701 3.89668 3.11398 5.19478 2.24715C6.70548 1.24666 8.44995 0.653709 10.2584 0.526091C12.0671 0.398451 13.8781 0.740654 15.515 1.51934C17.1519 2.29802 18.5588 3.48661 19.5989 4.9693C20.6389 6.45198 21.2767 8.17824 21.4501 9.97998Z"
          fill={fillColor}
          stroke={accentColor}
        />
        <ellipse cx="11" cy="10.5" rx="4.5" ry="4.5" fill={accentColor} />
      </svg> */}
      {isSelected ? (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="20" fill="#101828" fill-opacity="0.15" />
          <path
            d="M32.4407 16.5091L32.4408 16.5101C32.6205 18.2973 32.39 20.1013 31.7655 21.7914C31.141 23.4816 30.138 25.0161 28.8284 26.2832L28.826 26.2856L20.7511 34.202L20.7506 34.2024C20.6555 34.2959 20.5417 34.3708 20.4153 34.4221C20.2889 34.4734 20.1529 34.5 20.0153 34.5C19.8777 34.5 19.7417 34.4734 19.6153 34.4221C19.4889 34.3708 19.3751 34.2959 19.2799 34.2024L19.2788 34.2013L11.1733 26.2849L11.1716 26.2833C9.86197 25.0161 8.85898 23.4816 8.23451 21.7914C7.61009 20.1014 7.37951 18.2975 7.55919 16.5105C7.74255 14.7107 8.33256 12.9721 9.28756 11.4197C10.2425 9.86738 11.5389 8.53938 13.0844 7.5318C14.8831 6.36871 16.9612 5.67884 19.1163 5.53035C21.2718 5.38185 23.4295 5.78006 25.3791 6.68558C27.3287 7.59107 29.003 8.97256 30.24 10.6942C31.4769 12.4158 32.2347 14.4192 32.4407 16.5091Z"
            fill={fillColor}
            stroke={accentColor}
          />
          <ellipse cx="20" cy="17.1154" rx="5" ry="5.00012" fill={accentColor} />
        </svg>
      ) : (
        <svg
          width="26"
          height="30"
          viewBox="0 0 26 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25.4407 11.5091L25.4408 11.5101C25.6205 13.2973 25.39 15.1013 24.7655 16.7914C24.141 18.4816 23.138 20.0161 21.8284 21.2832L21.826 21.2856L13.7511 29.202L13.7506 29.2024C13.6555 29.2959 13.5417 29.3708 13.4153 29.4221C13.2889 29.4734 13.1529 29.5 13.0153 29.5C12.8777 29.5 12.7417 29.4734 12.6153 29.4221C12.4889 29.3708 12.3751 29.2959 12.2799 29.2024L12.2788 29.2013L4.17329 21.2849L4.1716 21.2833C2.86197 20.0161 1.85898 18.4816 1.23451 16.7914C0.610088 15.1014 0.379514 13.2975 0.559195 11.5105C0.742552 9.71068 1.33256 7.97213 2.28756 6.4197C3.2425 4.86738 4.53888 3.53938 6.08438 2.5318C7.88314 1.36871 9.96122 0.678836 12.1163 0.530353C14.2718 0.381848 16.4295 0.780059 18.3791 1.68558C20.3287 2.59107 22.003 3.97256 23.24 5.69424C24.4769 7.41582 25.2347 9.41918 25.4407 11.5091Z"
            fill={fillColor}
            stroke={accentColor}
          />
          <ellipse cx="13" cy="12.1154" rx="5" ry="5.00012" fill={accentColor} />
        </svg>
      )}
    </div>
  )
}
